import { Editor } from '@tiptap/react';
import {
  Image as ImageIcon,
  Minus,
} from 'lucide-react';
import { useState, useEffect, useRef } from 'react';

interface EditorContextMenuProps {
  editor: Editor;
  onOpenImageDialog: () => void;
}

export function EditorContextMenu({ editor, onOpenImageDialog }: EditorContextMenuProps) {
  const [showMenu, setShowMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const menuRef = useRef<HTMLDivElement>(null);

  // Debug effect to track menu position changes
  useEffect(() => {
  }, [menuPosition]);


  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      
      // Check if click is inside the editor
      const editorElement = editor.view.dom;
      if (!editorElement.contains(e.target as Node)) {
        return;
      }

      // Check if there's a text selection
      const { from, to } = editor.state.selection;
      const hasSelection = from !== to;

      // Show context menu for both selected and unselected text
      // (bubble menu will handle selected text formatting, context menu handles insertions)

      e.preventDefault();

      const newPosition = {
        top: e.clientY,
        left: e.clientX,
      };
      
      setMenuPosition(newPosition);
      setShowMenu(true);
    };

    const handleClick = (e: MouseEvent) => {
      // Add a small delay to prevent immediate closing when menu just appeared
      setTimeout(() => {
        if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
          setShowMenu(false);
        }
      }, 10);
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('click', handleClick);
    };
  }, [editor]);


  const handleInsertDivider = () => {
    editor.chain().focus().setHorizontalRule().run();
    setShowMenu(false);
  };

  if (!showMenu) {
    return null;
  }


  return (
    <>
      <div
        ref={menuRef}
        className="fixed bg-card border border-border rounded-lg shadow-xl overflow-hidden z-50 min-w-[200px] backdrop-blur-sm"
        style={{
          top: `${menuPosition.top}px`,
          left: `${menuPosition.left}px`,
        }}
      >
        <div className="py-1">
          {/* Add Image */}
          <button
            onClick={() => {
              onOpenImageDialog();
              setShowMenu(false);
            }}
            className="w-full px-4 py-2 text-left hover:bg-accent transition-colors flex items-center gap-3 text-sm text-foreground"
          >
            <ImageIcon className="w-4 h-4" />
            <span>Add Image</span>
          </button>

          {/* Add Divider */}
          <button
            onClick={handleInsertDivider}
            className="w-full px-4 py-2 text-left hover:bg-accent transition-colors flex items-center gap-3 text-sm text-foreground"
          >
            <Minus className="w-4 h-4" />
            <span>Add Divider</span>
          </button>
        </div>
      </div>
    </>
  );
}
